import React, { useState } from 'react';
import { TextAreaProps } from './TextArea.types';
import { ErrorMessage } from '../ErrorMessage/ErrorMessage';
import { QuestionMarkCircle } from '../../../icons/SvgIcons';

function TextArea({
  label,
  value,
  placeholder,
  onChange,
  rows = 4,
  disabled = false,
  error,
  hint
}: TextAreaProps) {
  const [hovered, setHovered] = useState(false);

  return (
    <div className="flex flex-col gap-1.5">
      {label && (
        <label className="flex gap-1 text-gray-800 text-left font-inter font-medium text-sm leading-5">
          {label}
          {hint && (
            <div
              title={hint}
              onMouseEnter={() => setHovered(true)}
              onMouseLeave={() => setHovered(false)}
            >
              {QuestionMarkCircle(hovered)}
            </div>
          )}
        </label>
      )}
      <textarea
        value={value}
        placeholder={placeholder}
        onChange={(e) => onChange(e.target.value)}
        rows={rows}
        disabled={disabled}
        className={`
          w-full p-2 
          border border-gray-300 rounded-md
          font-inter font-normal text-base leading-6 text-gray-900
          placeholder:text-gray-500
          shadow-sm
          focus:outline-purple-700 focus:ring-2 focus:ring-primary-400 focus:border-primary-400
          disabled:bg-gray-50 disabled:text-gray-500
          resize
          hover:border-purple-800
          ${
            error
              ? 'text-rose-800 border-rose-400 hover:border-rose-400 focus:border-rose-400 focus:outline-rose-400'
              : 'border-gray-300'
          }
        `}
        style={{
          boxShadow: '0px 1px 2px 0px rgba(0, 0, 0, 0.05)'
        }}
      />
      {error && <ErrorMessage message={error} />}
    </div>
  );
}

export default TextArea;
